import { useState } from "react";
import "./universalSimulator.css"
import Ch01Page001 from "./Content/Chapter 1/Page001";
import Ch01Page002 from "./Content/Chapter 1/Page002";
import Ch01Page003 from "./Content/Chapter 1/Page003";
import Ch01Page004 from "./Content/Chapter 1/Page004";
import Ch01Page005 from "./Content/Chapter 1/Page005";
import Ch02Page001 from "./Content/Chapter 2/Page001";
import Ch01Page006 from "./Content/Chapter 1/Page006";
import Ch01Page007 from "./Content/Chapter 1/Page007";
import Ch01Page008 from "./Content/Chapter 1/Page008";
import Ch01Page009 from "./Content/Chapter 1/Page009";
import Ch01Page010 from "./Content/Chapter 1/Page010";
import Ch01Page011 from "./Content/Chapter 1/Page011";
import Ch01Page012 from "./Content/Chapter 1/Page012";
import Ch01Page013 from "./Content/Chapter 1/Page013";
import Ch01Page014 from "./Content/Chapter 1/Page014";
import Ch01Page015 from "./Content/Chapter 1/Page015";
import Ch01Page016 from "./Content/Chapter 1/Page016";
import Ch01Page017 from "./Content/Chapter 1/Page017";
import Ch01Page018 from "./Content/Chapter 1/Page018";
import Ch01Page019 from "./Content/Chapter 1/Page019";
import Ch01Page020 from "./Content/Chapter 1/Page020";
import Ch01Page021 from "./Content/Chapter 1/Page021";
import Ch01Page022 from "./Content/Chapter 1/Page022";

const UniversalSimulator = () => {

    const pages = [
        <Ch01Page001 />,
        <Ch01Page002 />,
        <Ch01Page003 />,
        <Ch01Page004 />,
        <Ch01Page005 />,
        <Ch01Page006 />,
        <Ch01Page007 />,
        <Ch01Page008 />,
        <Ch01Page009 />,
        <Ch01Page010 />,
        <Ch01Page011 />,
        <Ch01Page012 />,
        <Ch01Page013 />,
        <Ch01Page014 />,
        <Ch01Page015 />,
        <Ch01Page016 />,
        <Ch01Page017 />,
        <Ch01Page018 />,
        <Ch01Page019 />,
        <Ch01Page020 />,
        <Ch01Page021 />,
        <Ch01Page022 />,
        <Ch02Page001 />
    ];

    function Book() {
        const [currentPage, setCurrentPage] = useState(0);

        const nextPage = () => {
            if (currentPage < pages.length - 1) setCurrentPage(currentPage + 1);
        };

        const prevPage = () => {
            if (currentPage > 0) setCurrentPage(currentPage - 1);
        };

        return (
            <div className="book">
                <div className="page">{pages[currentPage]}</div>
                <div className="controls">
                    <button onClick={prevPage} disabled={currentPage === 0}>Prev</button>
                    <button onClick={nextPage} disabled={currentPage === pages.length - 1}>Next</button>
                </div>
            </div>
        );
    };

    return <div id="universalSimulator">
        <Book />
    </div>
}

export default UniversalSimulator